import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    padding: ['50px 20px 60px', '80px 0px 130px'],
  },
  title: {
    color: 'violet.100',
    textAlign: 'center',
    marginBottom: ['20px', '100px'],
  },
  tabsContainer: {
    flexDirection: ['column', 'row'],
  },
  tabsContainerLeft: {
    flexDirection: 'column',
    borderLeft: ['none', '2px solid'],
    borderColor: ['unset', 'grayMedium.100'],
    paddingLeft: [null, '50px'],
    position: 'relative',
    textAlign: ['center', 'left'],

    '&:before': {
      content: [null, '""'],
      position: 'absolute',
      bottom: '0px',
      left: '-3px',
      width: '4px',
      height: '40px',
      backgroundColor: 'white',
    },
  },
  featureTab: {
    width: ['100%', '350px'],
    height: [null, '200px'],
    flexDirection: 'column',
    alignItems: ['center', 'flex-start'],
    justifyContent: 'flex-start',
    textAlign: ['center', 'left'],
    marginBottom: ['18px', 'inherit'],

    '&:hover': {
      cursor: 'pointer',
    },
  },
  featureTitle: {
    marginBottom: ['0px', '8px'],
    color: 'violet.100',
  },
  featureSubtitle: {
    color: 'black.100',
  },
  selectionBar: {
    display: ['none', 'block'],
    variant: 'backgrounds.gradient1Vertical',
    width: '8px',
    height: '160px',
    position: 'absolute',
    top: '0px',
    left: '-5px',
    borderRadius: '4px',
    transition: 'top 1s cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  tabsContainerRight: {
    flex: [null, '1'],
    position: 'relative',
  },
  featureContentContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    transition: 'opacity 1s cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  featureImage: {
    marginBottom: '18px',
  },
  featureContent: {
    marginBottom: ['32px', '40px'],
    color: 'black.100',
  },
  featureCta: {
    margin: ['0px auto', 'inherit'],
  },
};
